<div class="row">
    <div class="col-xs-12">
        <div class="row" *ngIf="loading">
            <div class="col-xs-12 loading-spinner text-center">
                <span>Loading</span>
                <span class="fa fa-spinner fa-spin"></span>
            </div>
        </div>
        <div class="row" *ngIf="!loading">
            <div class="col-xs-12">
                <table class="table table-bordered">
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                    </tr>
                    <tr *ngFor="let user of users">
                        <td>{{user.name}}</td>
                        <td>{{user.email}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
